import React, { useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Divider,
  Button,
} from "@mui/material";
import { AddOrUpdateUserNotifications } from "../../services/reportServices";

const NotificationMessagePopup = ({
  open,
  onClose,
  tenantNotifications = [],
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!open || tenantNotifications.length === 0) return null;

  const handleOK = async () => {
    if (dontShowAgain) {
      setLoading(true);
      try {
      await AddOrUpdateUserNotifications("true", tenantNotifications);
      } catch (error) {
        console.error("Failed to update notification preference", error);
      } finally {
        setLoading(false);
      }
    }
    onClose();
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: "25vh",
        left: "50%",
        transform: "translateX(-50%)",
        width: 520,
        maxWidth: "90vw",
        maxHeight: 300,
        bgcolor: "#fff",
        border: "1px solid #ddd",
        borderRadius: 2,
        boxShadow: "0px 8px 30px rgba(0,0,0,0.22)",
        overflow: "hidden",
        zIndex: 1500,
        userSelect: "text"
      }}
    >
     
     

      {/* Content */}
      <Box
        sx={{
          maxHeight: 210,
          overflowY: "auto",
          padding: "10px 18px",
          bgcolor: "#fff",
          "&::-webkit-scrollbar": { width: 8 },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#d0d8de",
            borderRadius: 4,
          },
        }}
      >
        {tenantNotifications.map((note, idx) => (
          <Box key={note.NotificationId} sx={{ marginBottom: idx + 1 !== tenantNotifications.length ? 2 : 0 }}>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: 16,
                color: "#337ab7",
                marginBottom: 0.5,
                marginTop: 1,
              }}
              variant="subtitle1"
            >
              {note.Heading}
            </Typography>

            {/*Divider between heading and message */}
              <Divider sx={{ borderColor: "#e0e0e0", marginY: 1 }} />

            <Typography
              sx={{ fontSize: 14, color: "#333", lineHeight: 1.5,marginBottom:1,marginTop: 1,}}
              dangerouslySetInnerHTML={{ __html: note.Message }} 
            />
            {idx + 1 !== tenantNotifications.length && <Divider sx={{ marginY: 1, borderColor: "#c0c0c0", borderWidth: "1.5px" }} />}
          </Box>
        ))}
      </Box>

      {/* Footer */}
      <Box
        sx={{
          padding: "8px 18px",
          borderTop: "1px solid #e5e5e5",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
              sx={{
                color: "#337ab7",
                "&.Mui-checked": { color: "#337ab7" },
              }}
            />
          }
          label={
            <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
              Don’t show this message again
            </Typography>
          }
        />
        <Button
          variant="contained"
          onClick={handleOK}
          disabled={loading}
          sx={{
            minWidth: 40,
            paddingX: 2,
            paddingY: 0.5,
            fontWeight: 700,
            fontSize: 10,
            backgroundColor: "#337ab7",
            textTransform: "none",
            borderRadius: 2,
            "&:hover": { backgroundColor: "#285e8e" },
            boxShadow: "0px 4px 10px rgba(51, 122, 183, 0.3)",
          }}
        >
          {loading ? "Saving..." : "OK"}
        </Button>
      </Box>
    </Box>
  );
};

export default NotificationMessagePopup;
